import angular from 'angular';

import { MeurhBeneficiosIndexController } from './index/beneficios.index.controller';
import { MeurhBeneficiosNewController } from './new/beneficios.new.controller';
import { MeurhBeneficiosShowController } from './show/beneficios.show.controller';
import { PlanosModalController } from './modal/planos/planos.modal.controller';
import { CancelamentoModalController } from './modal/cancelamento/cancelamento.modal.controller';
import { SuspensaoModalController } from './modal/suspensao/suspensao.modal.controller';
import { ProrrogacaoModalController } from './modal/prorrogacao/prorrogacao.modal.controller';
import { TrocaModalController } from './modal/troca/troca.modal.controller';
import { ReativacaoModalController } from './modal/reativacao/reativacao.modal.controller';

import { MeurhBeneficiosComponent } from './beneficios.component';
import { MeurhBeneficiosHistoricoComponent } from './historico/beneficios.historico.component';
import { MeurhBeneficiosAlertaComponent } from './alerta/beneficios.alerta.component';
import { MeurhBeneficiosInclusaoFormComponent } from './form/inclusao/inclusao.form.component';
import { MeurhBeneficiosCancelamentoFormComponent } from './form/cancelamento/cancelamento.form.component';
import { MeurhBeneficiosSuspensaoFormComponent } from './form/suspensao/suspensao.form.component';
import { MeurhBeneficiosProrrogacaoFormComponent } from './form/prorrogacao/prorrogacao.form.component';
import { MeurhBeneficiosTrocaFormComponent } from './form/troca/troca.form.component';
import { MeurhBeneficiosReativacaoFormComponent } from './form/reativacao/reativacao.form.component';

import { MeurhBeneficiosService } from './beneficios.service';
import { PlanosModalService } from './modal/planos/planos.modal.service';
import { CancelamentoModalService } from './modal/cancelamento/cancelamento.modal.service';
import { SuspensaoModalService } from './modal/suspensao/suspensao.modal.service';
import { ProrrogacaoModalService } from './modal/prorrogacao/prorrogacao.modal.service';
import { TrocaModalService } from './modal/troca/troca.modal.service';
import { ReativacaoModalService } from './modal/reativacao/reativacao.modal.service';

import { MeurhBeneficiosListRouting } from './beneficios.routes';

export const MeurhBeneficiosModule = angular.module('MeurhBeneficiosModule', ['ui.router.state'])
    .controller('MeurhBeneficiosIndexController', MeurhBeneficiosIndexController)
    .controller('MeurhBeneficiosNewController', MeurhBeneficiosNewController)
    .controller('MeurhBeneficiosShowController', MeurhBeneficiosShowController)
    .controller('PlanosModalController', PlanosModalController)
    .controller('CancelamentoModalController', CancelamentoModalController)
    .controller('SuspensaoModalController', SuspensaoModalController)
    .controller('ProrrogacaoModalController', ProrrogacaoModalController)
    .controller('TrocaModalController', TrocaModalController)
    .controller('ReativacaoModalController', ReativacaoModalController)
    .component('meurhBeneficiosComponent', MeurhBeneficiosComponent)
    .component('meurhBeneficiosHistoricoComponent', MeurhBeneficiosHistoricoComponent)
    .component('meurhBeneficiosAlertaComponent', MeurhBeneficiosAlertaComponent)
    .component('meurhBeneficiosInclusaoFormComponent', MeurhBeneficiosInclusaoFormComponent)
    .component('meurhBeneficiosCancelamentoFormComponent', MeurhBeneficiosCancelamentoFormComponent)
    .component('meurhBeneficiosSuspensaoFormComponent', MeurhBeneficiosSuspensaoFormComponent)
    .component('meurhBeneficiosProrrogacaoFormComponent', MeurhBeneficiosProrrogacaoFormComponent)
    .component('meurhBeneficiosTrocaFormComponent', MeurhBeneficiosTrocaFormComponent)
    .component('meurhBeneficiosReativacaoFormComponent', MeurhBeneficiosReativacaoFormComponent)
    .service('MeurhBeneficiosService', MeurhBeneficiosService)
    .service('PlanosModalService', PlanosModalService)
    .service('CancelamentoModalService', CancelamentoModalService)
    .service('SuspensaoModalService', SuspensaoModalService)
    .service('ProrrogacaoModalService', ProrrogacaoModalService)
    .service('TrocaModalService', TrocaModalService)
    .service('ReativacaoModalService', ReativacaoModalService)
    .config(MeurhBeneficiosListRouting)
    .name;
